import http from "@/api/http.js";

function listAll() {
  return http({
    url: "/PmsErp/List",
    method: "get",
  });
}

export default {
  listAll,
};
